import { render } from "./shipping.component.vue?vue&type=template&id=1a4e9b18&scoped=true&ts=true"
import script from "./shipping.component.vue?vue&type=script&lang=ts"
export * from "./shipping.component.vue?vue&type=script&lang=ts"

import "./shipping.component.vue?vue&type=style&index=0&id=1a4e9b18&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a4e9b18"]])

export default __exports__